<template>
  <common-dialog ref="dialog" width="100%" :title="boxtitle" @closed="onClosed">
    <el-tabs v-model="tabActive" type="card" class="cardTabs" :class="data.QueryPlanId?'hideHeader':''" @tab-click="tabChange">
      <el-tab-pane label="默认查询" name="0">
        <div class="query-box">
          <el-collapse v-model="active">
            <el-collapse-item title="查询属性" name="1">
              <el-row class="row-border">
                <div class="property-row">
                  <div class="row-title">基本信息</div>
                  <div class="row-content">
                    <template v-for="(i,key) in BaseInfo">
                      <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                    </template>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">育人工作</div>
                  <div class="row-content">
                    <div class="subrow">
                      <div class="subtitle">主题班会</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Theme">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">个人德育类荣誉</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in EduHoner">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">个人德育类奖项</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in EduAward">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 130px;">所带班级表彰奖励</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in ClassAward">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">课程教学</div>
                  <div class="row-content">
                    <div class="subrow">
                      <div class="subtitle">公开课</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in OpenClass">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">教学1类竞赛获奖</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Edu1Race">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">教学2类竞赛获奖</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Edu2Race">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">教学类荣誉</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in TeachHoner">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">教科研</div>
                  <div class="row-content">
                    <div class="subrow">
                      <div class="subtitle">论文发表</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Paper">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 120px;">教育科研项目</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in EduProject">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle">著作出版</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Book">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 130px;">教育教学科研成果</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in EduResult">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">示范引领</div>
                  <div class="row-content">
                    <div class="subrow">
                      <div class="subtitle" style="width: 110px;">参加学术团体</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Group">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle">指导教师</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in GuideTeacher">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle">专题讲座</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in Lecture">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="subtitle" style="width: 110px;">综合性荣誉称号</div>
                      <div class="subcontent">
                        <template v-for="(i,key) in ComHoner">
                          <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">指导学生</div>
                  <div class="row-content">
                    <template v-for="(i,key) in GuideStudent">
                      <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                    </template>
                  </div>
                </div>
                <div class="property-row">
                  <div class="row-title">学习培训</div>
                  <div class="row-content">
                    <template v-for="(i,key) in Train">
                      <el-checkbox :key="key" v-model="i.Checked" @change="onChange(i)">{{i.Name}}</el-checkbox>
                    </template>
                  </div>
                </div>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <div class="row-head" style="line-height: 48px;">查询条件</div>
          <el-row class="row-border" style="padding: 10px;">
            <template v-if="showTitle('基本信息')">
              <div class="row-head">基本信息</div>
              <div class="query-row">
                <div class="item-row">
                  <div class="row-title">个人基本信息</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="现任年级" v-show="Query['BaseInfo_NowGradeIds'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_NowGradeIds'].Value1"
                        collapse-tags
                        clearable
                        multiple
                        placeholder="请选择现任年级"
                      >
                        <template v-for="(i,key) in gradeList">
                          <el-option :key="key" :label="i.Grade" :value="i.GradeId"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="科目" v-show="Query['BaseInfo_Subjects'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_Subjects'].Value1"
                        collapse-tags
                        clearable
                        multiple
                        placeholder="请选择科目"
                      >
                        <template v-for="(i,key) in subjectList">
                          <el-option :key="key" :label="i.Subject" :value="i.Subject"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="姓名" v-show="Query['BaseInfo_TeacherName'].Checked">
                      <el-input
                        v-model="Query['BaseInfo_TeacherName'].Value1"
                        placeholder="请填写姓名"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="性别" v-show="Query['BaseInfo_Sex'].Checked">
                      <el-select v-model="Query['BaseInfo_Sex'].Value1" clearable placeholder="请选择性别">
                        <el-option label="无" :value="0"></el-option>
                        <el-option label="男" :value="1"></el-option>
                        <el-option label="女" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="入职年份" v-show="Query['BaseInfo_InYear'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_InYear'].Value1"
                        clearable
                        placeholder="请选择入职年份"
                      >
                        <template v-for="(i,key) in yearList">
                          <el-option :key="key" :label="i" :value="i"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="最高学历" v-show="Query['BaseInfo_Edu'].Checked">
                      <el-select v-model="Query['BaseInfo_Edu'].Value1" clearable placeholder="请选择最高学历">
                        <template v-for="(i,key) in zgxl">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="政治面貌" v-show="Query['BaseInfo_Politics'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_Politics'].Value1"
                        clearable
                        placeholder="请选择政治面貌"
                      >
                        <el-option label="党员" value="党员"></el-option>
                        <el-option label="非党员" value="非党员"></el-option>
                        <el-option label="民盟" value="民盟"></el-option>
                        <el-option label="民进" value="民进"></el-option>
                        <el-option label="农工" value="农工"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="兼任职务" v-show="Query['BaseInfo_JobNames'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_JobNames'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择职务"
                      >
                        <template v-for="(i,key) in jobList">
                          <el-option :key="key" :label="i.JobName" :value="i.JobName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="职称" v-show="Query['BaseInfo_Titles'].Checked">
                      <el-select
                        v-model="Query['BaseInfo_Titles'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择职称"
                      >
                        <el-option label="未定级" value="未定级"></el-option>
                        <el-option label="二级" value="二级"></el-option>
                        <el-option label="一级" value="一级"></el-option>
                        <el-option label="高级" value="高级"></el-option>
                        <el-option label="正高级" value="正高级"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否完成支教" v-show="Query['BaseInfo_HasSupport'].Checked">
                      <el-select v-model="Query['BaseInfo_HasSupport'].Value1" clearable>
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="任现职称年限"
                      v-show="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Checked"
                    >
                      <div style="display: flex;width: 210px;">
                        <el-input
                          v-model="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Value1"
                          v-int
                          clearable
                        />
                        <span style="margin: 0 5px;">-</span>
                        <el-input
                          v-model="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Value2"
                          v-int
                          clearable
                        />
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="德育总年限"
                      v-show="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Checked"
                    >
                      <div style="display: flex;width: 210px;">
                        <el-input
                          v-model="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Value1"
                          v-int
                          clearable
                        />
                        <span style="margin: 0 5px;">-</span>
                        <el-input
                          v-model="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Value2"
                          v-int
                          clearable
                        />
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="任现职德育总年限"
                      v-show="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Checked"
                    >
                      <div style="display: flex;width: 210px;">
                        <el-input
                          v-model="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Value1"
                          v-int
                          clearable
                        />
                        <span style="margin: 0 5px;">-</span>
                        <el-input
                          v-model="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Value2"
                          v-int
                          clearable
                        />
                      </div>
                    </el-form-item>
                    <el-form-item label="任现职是否完成大循环" v-show="Query['BaseInfo_GradeCycle'].Checked">
                      <el-select v-model="Query['BaseInfo_GradeCycle'].Value1" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="任现职是否任高三3年以上" v-show="Query['BaseInfo_Grade3More'].Checked">
                      <el-select v-model="Query['BaseInfo_Grade3More'].Value1" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('育人工作')">
              <div class="row-head">育人工作</div>
              <div class="query-row">
                <div class="item-row" v-show="showSubTitle('Theme')">
                  <div class="row-title">主题班会</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="承担时间"
                      v-show="Query['Theme_BearStartDate,Theme_BearEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Theme_BearStartDate,Theme_BearEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Theme_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Theme_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('EduHoner')">
                  <div class="row-title">个人德育类荣誉</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="荣誉名称" v-show="Query['EduHoner_EduHonerName'].Checked">
                      <el-select
                        v-model="Query['EduHoner_EduHonerName'].Value1"
                        clearable
                        placeholder="请选择荣誉名称"
                      >
                        <template v-for="(i,key) in dylrymc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['EduHoner_GetStartDate,EduHoner_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['EduHoner_GetStartDate,EduHoner_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['EduHoner_GdLvs'].Checked">
                      <el-select
                        v-model="Query['EduHoner_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('EduAward')">
                  <div class="row-title">个人德育类奖项</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="项目名称" v-show="Query['EduAward_EduAwardName'].Checked">
                      <el-select
                        v-model="Query['EduAward_EduAwardName'].Value1"
                        clearable
                        placeholder="请选择项目名称"
                      >
                        <template v-for="(i,key) in dyljxmc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['EduAward_GetStartDate,EduAward_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['EduAward_GetStartDate,EduAward_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['EduAward_GdLvs'].Checked">
                      <el-select
                        v-model="Query['EduAward_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="等次" v-show="Query['EduAward_GdGrades'].Checked">
                      <el-select
                        v-model="Query['EduAward_GdGrades'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择等次"
                      >
                        <template v-for="(i,key) in dc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('ClassAward')">
                  <div class="row-title">所带班级表彰奖励</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="表彰名称" v-show="Query['ClassAward_ClassAwardName'].Checked">
                      <el-select
                        v-model="Query['ClassAward_ClassAwardName'].Value1"
                        clearable
                        placeholder="请选择表彰名称"
                      >
                        <template v-for="(i,key) in sdbjbzmc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="表彰时间"
                      v-show="Query['ClassAward_GetStartDate,ClassAward_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['ClassAward_GetStartDate,ClassAward_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['ClassAward_GdLvs'].Checked">
                      <el-select
                        v-model="Query['ClassAward_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="等次" v-show="Query['ClassAward_GdGrades'].Checked">
                      <el-select
                        v-model="Query['ClassAward_GdGrades'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择等次"
                      >
                        <template v-for="(i,key) in dc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('课程教学')">
              <div class="row-head">课程教学</div>
              <div class="query-row">
                <div class="item-row" v-show="showSubTitle('OpenClass')">
                  <div class="row-title">公开课</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="承担时间"
                      v-show="Query['OpenClass_BearStartDate,OpenClass_BearEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['OpenClass_BearStartDate,OpenClass_BearEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['OpenClass_GdLvs'].Checked">
                      <el-select
                        v-model="Query['OpenClass_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('Edu1Race')">
                  <div class="row-title">教学1类竞赛获奖</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="项目名称" v-show="Query['Edu1Race_Edu1RaceName'].Checked">
                      <el-select
                        v-model="Query['Edu1Race_Edu1RaceName'].Value1"
                        clearable
                        placeholder="请选择项目名称"
                      >
                        <template v-for="(i,key) in jx1ljsjx">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['Edu1Race_GetStartDate,Edu1Race_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Edu1Race_GetStartDate,Edu1Race_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类型" v-show="Query['Edu1Race_GdTypes'].Checked">
                      <el-select
                        v-model="Query['Edu1Race_GdTypes'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类型"
                      >
                        <template v-for="(i,key) in lx">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Edu1Race_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Edu1Race_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="等次" v-show="Query['Edu1Race_GdGrades'].Checked">
                      <el-select
                        v-model="Query['Edu1Race_GdGrades'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择等次"
                      >
                        <template v-for="(i,key) in dc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('Edu2Race')">
                  <div class="row-title">教学2类竞赛获奖</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="项目名称" v-show="Query['Edu2Race_Edu2RaceName'].Checked">
                      <el-select
                        v-model="Query['Edu2Race_Edu2RaceName'].Value1"
                        clearable
                        placeholder="请选择项目名称"
                      >
                        <template v-for="(i,key) in jx2ljsjx">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['Edu2Race_GetStartDate,Edu2Race_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Edu2Race_GetStartDate,Edu2Race_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类型" v-show="Query['Edu2Race_GdTypes'].Checked">
                      <el-select
                        v-model="Query['Edu2Race_GdTypes'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类型"
                      >
                        <template v-for="(i,key) in lx">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Edu2Race_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Edu2Race_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="等次" v-show="Query['Edu2Race_GdGrades'].Checked">
                      <el-select
                        v-model="Query['Edu2Race_GdGrades'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择等次"
                      >
                        <template v-for="(i,key) in dc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('TeachHoner')">
                  <div class="row-title">教学类荣誉</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="所属项目" v-show="Query['TeachHoner_TeachHonerName'].Checked">
                      <el-select
                        v-model="Query['TeachHoner_TeachHonerName'].Value1"
                        clearable
                        placeholder="请选择所属项目"
                      >
                        <template v-for="(i,key) in jxlryssxm">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['TeachHoner_GetStartDate,TeachHoner_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['TeachHoner_GetStartDate,TeachHoner_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['TeachHoner_GdLvs'].Checked">
                      <el-select
                        v-model="Query['TeachHoner_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('教科研')">
              <div class="row-head">教科研</div>
              <div class="query-row">
                <div class="item-row" v-show="showSubTitle('Paper')">
                  <div class="row-title">论文发表</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="发表时间"
                      v-show="Query['Paper_PublishStartDate,Paper_PublishEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Paper_PublishStartDate,Paper_PublishEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['Paper_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['Paper_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Paper_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Paper_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="本人角色" v-show="Query['Paper_Roles'].Checked">
                      <el-select
                        v-model="Query['Paper_Roles'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择本人角色"
                      >
                        <el-option label="独立撰写" value="独立撰写"></el-option>
                        <el-option label="第一作者" value="第一作者"></el-option>
                        <el-option label="第二作者" value="第二作者"></el-option>
                        <el-option label="其它" value="其它"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('EduProject')">
                  <div class="row-title">教科研项目</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="立项时间"
                      v-show="Query['EduProject_ProjectStartDate,EduProject_ProjectEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['EduProject_ProjectStartDate,EduProject_ProjectEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item
                      label="结题时间"
                      v-show="Query['EduProject_FinishStartDate,EduProject_FinishEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['EduProject_FinishStartDate,EduProject_FinishEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['EduProject_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['EduProject_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['EduProject_GdLvs'].Checked">
                      <el-select
                        v-model="Query['EduProject_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="本人角色" v-show="Query['EduProject_Roles'].Checked">
                      <el-select
                        v-model="Query['EduProject_Roles'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择本人角色"
                      >
                        <el-option label="主持人" value="主持人"></el-option>
                        <el-option label="主要参与者" value="主要参与者"></el-option>
                        <el-option label="参与者" value="参与者"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('Book')">
                  <div class="row-title">著作出版</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="出版时间"
                      v-show="Query['Book_PublishStartDate,Book_PublishEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Book_PublishStartDate,Book_PublishEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['Book_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['Book_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="本人撰写部分" v-show="Query['Book_WriteParts'].Checked">
                      <el-select
                        v-model="Query['Book_WriteParts'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择本人撰写部分"
                      >
                        <template v-for="(i,key) in brzxbf">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('EduResult')">
                  <div class="row-title">教育教学科研成果</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="奖项名称" v-show="Query['EduResult_EduResultName'].Checked">
                      <el-input
                        v-model="Query['EduResult_EduResultName'].Value1"
                        placeholder="请填写奖项名称"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['EduResult_GetStartDate,EduResult_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['EduResult_GetStartDate,EduResult_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['EduResult_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['EduResult_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['EduResult_GdLvs'].Checked">
                      <el-select
                        v-model="Query['EduResult_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="等次" v-show="Query['EduResult_GdGrades'].Checked">
                      <el-select
                        v-model="Query['EduResult_GdGrades'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择等次"
                      >
                        <template v-for="(i,key) in dc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('示范引领')">
              <div class="row-head">示范引领</div>
              <div class="query-row">
                <div class="item-row" v-show="showSubTitle('Group')">
                  <div class="row-title">参加学术团体</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="团体名称" v-show="Query['Group_GroupName'].Checked">
                      <el-select
                        v-model="Query['Group_GroupName'].Value1"
                        clearable
                        placeholder="请选择团体名称"
                      >
                        <template v-for="(i,key) in ttmc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="加入时间"
                      v-show="Query['Group_JoinStartDate,Group_JoinEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Group_JoinStartDate,Group_JoinEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['Group_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['Group_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Group_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Group_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="本人角色" v-show="Query['Group_Roles'].Checked">
                      <el-select
                        v-model="Query['Group_Roles'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择本人角色"
                      >
                        <el-option label="主持人" value="主持人"></el-option>
                        <el-option label="主要参与者" value="主要参与者"></el-option>
                        <el-option label="参与者" value="参与者"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('GuideTeacher')">
                  <div class="row-title">指导教师</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="项目名称" v-show="Query['GuideTeacher_GuideTeacherName'].Checked">
                      <el-select
                        v-model="Query['GuideTeacher_GuideTeacherName'].Value1"
                        clearable
                        placeholder="请选择项目名称"
                      >
                        <template v-for="(i,key) in zdjsxmmc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="项目时间"
                      v-show="Query['GuideTeacher_ProjectStartDate,GuideTeacher_ProjectEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['GuideTeacher_ProjectStartDate,GuideTeacher_ProjectEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['GuideTeacher_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['GuideTeacher_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['GuideTeacher_GdLvs'].Checked">
                      <el-select
                        v-model="Query['GuideTeacher_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('Lecture')">
                  <div class="row-title">专题讲座</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item
                      label="承担时间"
                      v-show="Query['Lecture_BearStartDate,Lecture_BearEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Lecture_BearStartDate,Lecture_BearEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['Lecture_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['Lecture_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Lecture_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Lecture_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="item-row" v-show="showSubTitle('ComHoner')">
                  <div class="row-title">综合性荣誉称号</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="荣誉名称" v-show="Query['ComHoner_ComHonerName'].Checked">
                      <el-select
                        v-model="Query['ComHoner_ComHonerName'].Value1"
                        clearable
                        placeholder="请选择荣誉名称"
                      >
                        <template v-for="(i,key) in zhxrymc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="获得时间"
                      v-show="Query['ComHoner_GetStartDate,ComHoner_GetEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['ComHoner_GetStartDate,ComHoner_GetEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['ComHoner_GdLvs'].Checked">
                      <el-select
                        v-model="Query['ComHoner_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('指导学生')">
              <div class="row-head">指导学生</div>
              <div class="query-row">
                <div class="item-row">
                  <div class="row-title">指导学生</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="项目名称" v-show="Query['GuideStudent_GuideStudentName'].Checked">
                      <el-select
                        v-model="Query['GuideStudent_GuideStudentName'].Value1"
                        clearable
                        placeholder="请选择项目名称"
                      >
                        <template v-for="(i,key) in zdxsxmmc">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="项目时间"
                      v-show="Query['GuideStudent_ProjectStartDate,GuideStudent_ProjectEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['GuideStudent_ProjectStartDate,GuideStudent_ProjectEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类别" v-show="Query['GuideStudent_GdCategorys'].Checked">
                      <el-select
                        v-model="Query['GuideStudent_GdCategorys'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类别"
                      >
                        <template v-for="(i,key) in lb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['GuideStudent_GdLvs'].Checked">
                      <el-select
                        v-model="Query['GuideStudent_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-if="showTitle('学习培训')">
              <div class="row-head">学习培训</div>
              <div class="query-row">
                <div class="item-row">
                  <div class="row-title">学习培训</div>
                  <el-form class="row-content" label-width="100px">
                    <el-form-item label="活动主题" v-show="Query['Train_Theme'].Checked">
                      <el-select
                        v-model="Query['Train_Theme'].Value1"
                        clearable
                        placeholder="请选择活动主题"
                      >
                        <template v-for="(i,key) in pxhdzt">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="活动时间"
                      v-show="Query['Train_ProjectStartDate,Train_ProjectEndDate'].Checked"
                    >
                      <el-date-picker
                        v-model="Query['Train_ProjectStartDate,Train_ProjectEndDate'].Value1"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item label="类型" v-show="Query['Train_GdTypes'].Checked">
                      <el-select
                        v-model="Query['Train_GdTypes'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择类型"
                      >
                        <template v-for="(i,key) in pxlx">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="级别" v-show="Query['Train_GdLvs'].Checked">
                      <el-select
                        v-model="Query['Train_GdLvs'].Value1"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择级别"
                      >
                        <template v-for="(i,key) in jb">
                          <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="组合查询" name="1">
        <group-search ref="groupSearch" />
      </el-tab-pane>
    </el-tabs>
    <template slot="footer">
      <el-button type="success" @click="save">保存查询方案</el-button>
      <el-button type="primary" v-if="data.QueryPlanId==0&&tabActive=='0'" @click="search">查 询</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
    <save-dialog ref="saveDialog" @close-saved="onCloseSaved" />
  </common-dialog>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import saveDialog from "./saveDialog";
import groupSearch from "./groupSearch";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    saveDialog,
    groupSearch
  },
  data() {
    return {
      boxtitle: "设置查询方案",
      tabActive: "0",
      data: {
        QueryPlanId: 0,
        QueryPlanType: 0,
        QueryPlanName: "",
        TeacherId: 0,
      },
      //CheckItems
      BaseInfo: [], //基本信息 - 个人基本信息
      Theme: [], //育人工作 - 主题班会
      EduHoner: [], //育人工作 - 个人德育类荣誉
      EduAward: [], //育人工作 - 个人德育类奖项
      ClassAward: [], //育人工作 - 所带班级表彰获奖
      OpenClass: [], //课程教学 - 公开课
      Edu1Race: [], //课程教学 - 教学1类竞赛获奖
      Edu2Race: [], //课程教学 - 教学2类竞赛获奖
      TeachHoner: [], //课程教学 - 教学类荣誉
      Paper: [], //教科研 - 论文发表
      EduProject: [], //教科研 - 教育科研项目
      Book: [], //教科研 - 著作出版
      EduResult: [], //教科研 - 教育教学科研成果
      Group: [], //示范引领 - 参加学术团体
      GuideTeacher: [], //示范引领 - 指导教师
      Lecture: [], //示范引领 - 专题讲座
      ComHoner: [], //示范引领 - 综合性荣誉称号
      GuideStudent: [], //指导学生 - 指导学生
      Train: [], //学习培训 - 学习培训
      //QueryItem
      Query: JSON.parse(JSON.stringify(require("./queryItems.json"))),
      active: ["1"],
      yearList: [], //年份
      gradeList: [], //年级
      jobList: [], //职务
      subjectList: [], //科目
      lx: [], //类型
      pxlx: [], //培训类型
      jb: [], //级别
      hdjb: [], //活动级别
      dc: [], //等次
      lb: [], //类别
      zgxl: [], //最高学历
      dylrymc: [], //德育类荣誉名称
      dyljxmc: [], //德育类奖项名称
      dylbzmc: [], //德育类表彰名称
      sdbjbzmc: [], //所带班级表彰名称
      ttmc: [], //团体名称
      pxhdzt: [], //培训活动主题
      brzxbf: [], //本人撰写部分
      zhxrymc: [], //综合性荣誉名称
      jx1ljsjx: [], //教学1类竞赛奖项名称
      jx2ljsjx: [], //教学2类竞赛奖项名称
      jxlryssxm: [], //教学类荣誉所属项目
      zdjsxmmc: [], //指导教师项目名称
      zdxsxmmc: [], //指导学生项目名称
      api: require("@/api/gd/queryplan").default,
      grade_api: require("@/api/ed/grade").default,
      job_api: require("@/api/ent/job").default,
      subject_api: require("@/api/ed/subject").default,
      base_api: require("@/api/gd/basedata").default,
    };
  },
  computed: {},
  methods: {
    getData(data) {
      this.getOptions();
      var c_items = JSON.parse(JSON.stringify(require("./checkItems.json")));
      if (data) {
        this.data.QueryPlanId = data.QueryPlanId;
        this.data.QueryPlanName = data.QueryPlanName;
        this.data.TeacherId = data.TeacherId;
        if(data.QueryPlanType == 0) {
          data.Dts.forEach((x) => {
            var items = c_items[x.ApiParamName.split("_")[0]].Items;
            var has = items.find((i) => i.Identify == x.ApiParamName);
            if (has) has.Checked = true;
            this.Query[x.ApiParamName].QueryPlanDtsId = x.QueryPlanDtsId;
            this.Query[x.ApiParamName].QueryPlanId = x.QueryPlanId;
            this.Query[x.ApiParamName].DtsName = x.DtsName;
            this.Query[x.ApiParamName].ApiParamName = x.ApiParamName;
            this.Query[x.ApiParamName].Checked = true;
            this.Query[x.ApiParamName].T = 1;
            this.conver(this.Query[x.ApiParamName], x);
          });
        } else {
          this.$refs.groupSearch.begin(data);
        }
        this.tabActive = data.QueryPlanType==0?"0":"1";
      } else {
        this.$refs.groupSearch.begin();
      }
      for (let key of Object.keys(c_items)) {
        this[key] = c_items[key].Items;
      }
    },
    getOptions() {
      var date = new Date();
      this.yearList.push(1900);
      for (let i = 1900; i <= date.getFullYear(); i++) {
        this.yearList.push(i);
      }
      this.yearList.reverse();
      this.grade_api.list({}).then((res) => {
        this.gradeList = res.Data;
      });
      this.job_api.list({}).then((res) => {
        this.jobList = res.Data;
      });
      this.subject_api.list({}).then((res) => {
        this.subjectList = res.Data;
      });
      this.base_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) {
          this.lx = res.Data.filter((x) => x.ClassName == "类型");
          this.pxlx = res.Data.filter((x) => x.ClassName == "培训类型");
          this.jb = res.Data.filter((x) => x.ClassName == "级别");
          this.hdjb = res.Data.filter((x) => x.ClassName == "活动级别");
          this.dc = res.Data.filter((x) => x.ClassName == "等次");
          this.zgxl = res.Data.filter((x) => x.ClassName == "最高学历");
          this.dylrymc = res.Data.filter(
            (x) => x.ClassName == "德育类荣誉名称"
          );
          this.dyljxmc = res.Data.filter(
            (x) => x.ClassName == "德育类奖项名称"
          );
          this.dylbzmc = res.Data.filter(
            (x) => x.ClassName == "德育类表彰名称"
          );
          this.sdbjbzmc = res.Data.filter(
            (x) => x.ClassName == "所带班级表彰名称"
          );
          this.ttmc = res.Data.filter((x) => x.ClassName == "团体名称");
          this.pxhdzt = res.Data.filter((x) => x.ClassName == "培训活动主题");
          this.lb = res.Data.filter((x) => x.ClassName == "类别");
          this.brzxbf = res.Data.filter((x) => x.ClassName == "本人撰写部分");
          this.zhxrymc = res.Data.filter(
            (x) => x.ClassName == "综合性荣誉名称"
          );
          this.jx1ljsjx = res.Data.filter(
            (x) => x.ClassName == "教学1类竞赛奖项名称"
          );
          this.jx2ljsjx = res.Data.filter(
            (x) => x.ClassName == "教学2类竞赛奖项名称"
          );
          this.jxlryssxm = res.Data.filter(
            (x) => x.ClassName == "教学类荣誉所属项目"
          );
          this.zdjsxmmc = res.Data.filter(
            (x) => x.ClassName == "指导教师项目名称"
          );
          this.zdxsxmmc = res.Data.filter(
            (x) => x.ClassName == "指导学生项目名称"
          );
          this.pxhdzt = res.Data.filter((x) => x.ClassName == "培训活动主题");
        }
      });
    },
    conver(data, source) {
      switch (data.ParamType) {
        case "Array":
          if (source.ApiParamValue) {
            var arr = source.ApiParamValue.split(",");
            data.Value1 = arr.map((x) => {
              var num = Number(x);
              if (isNaN(num)) return x;
              else return num;
            });
          } else {
            data.Value1 = [];
          }
          break;
        case "Date":
          if (source.ApiParamValue) {
            data.Value1 = source.ApiParamValue.split(",");
          }
          break;
        case "Bool":
          if (source.ApiParamValue === "" || source.ApiParamValue === null) {
            data.Value1 = null;
          } else data.Value1 = source.ApiParamValue === "true";
          break;
        case "Interval":
          if (source.ApiParamValue) {
            var values = source.ApiParamValue.split(",");
            data.Value1 = values[0];
            data.Value2 = values[1];
          }
          break;
        default:
          if (source.ApiParamValue == "" || source.ApiParamValue == null) {
            data.Value1 = source.ApiParamValue;
          } else {
            var num = Number(source.ApiParamValue);
            if (isNaN(num)) data.Value1 = source.ApiParamValue;
            else data.Value1 = num;
          }
          break;
      }
    },
    turnBack(data, source) {
      switch (source.ParamType) {
        case "Array":
          if (source.Value1) data.ApiParamValue = source.Value1.join(",");
          break;
        case "Date":
          if (source.Value1) data.ApiParamValue = source.Value1.join(",");
          break;
        case "Bool":
          if (source.Value1 === "" || source.Value1 === null) {
            data.ApiParamValue = null;
          } else data.ApiParamValue = source.Value1;
          break;
        case "Interval":
          data.ApiParamValue = source.Value1 + "," + source.Value2;
          break;
        default:
          data.ApiParamValue = source.Value1;
          break;
      }
    },
    onChange(item) {
      console.log(item.Identify);
      var qt = this.Query[item.Identify];
      if (item.Checked) {
        this.Query[item.Identify].T = qt.T == 0 ? 0 : 1;
      } else {
        this.Query[item.Identify].T = qt.T != 0 ? 2 : 0;
      }
      this.Query[item.Identify].Checked = item.Checked;
    },
    showTitle(type) {
      switch (type) {
        case "基本信息":
          return this.BaseInfo.some((x) => x.Checked == true);
          break;
        case "育人工作":
          var Theme = this.Theme.some((x) => x.Checked == true);
          var EduHoner = this.EduHoner.some((x) => x.Checked == true);
          var EduAward = this.EduAward.some((x) => x.Checked == true);
          var ClassAward = this.ClassAward.some((x) => x.Checked == true);
          return Theme || EduHoner || EduAward || ClassAward;
          break;
        case "课程教学":
          var OpenClass = this.OpenClass.some((x) => x.Checked == true);
          var Edu1Race = this.Edu1Race.some((x) => x.Checked == true);
          var Edu2Race = this.Edu2Race.some((x) => x.Checked == true);
          var TeachHoner = this.TeachHoner.some((x) => x.Checked == true);
          return OpenClass || Edu1Race || Edu2Race || TeachHoner;
          break;
        case "教科研":
          var Paper = this.Paper.some((x) => x.Checked == true);
          var EduProject = this.EduProject.some((x) => x.Checked == true);
          var Book = this.Book.some((x) => x.Checked == true);
          var EduResult = this.EduResult.some((x) => x.Checked == true);
          return Paper || EduProject || Book || EduResult;
          break;
        case "示范引领":
          var Group = this.Group.some((x) => x.Checked == true);
          var GuideTeacher = this.GuideTeacher.some((x) => x.Checked == true);
          var Lecture = this.Lecture.some((x) => x.Checked == true);
          var ComHoner = this.ComHoner.some((x) => x.Checked == true);
          return Group || GuideTeacher || Lecture || ComHoner;
          break;
        case "指导学生":
          return this.GuideStudent.some((x) => x.Checked == true);
          break;
        case "学习培训":
          return this.Train.some((x) => x.Checked == true);
          break;
      }
    },
    showSubTitle(type) {
      return this[type].some((x) => x.Checked == true);
    },
    save() {
      if(this.tabActive == "0") {
        var dts = [];
        for (let key of Object.keys(this.Query)) {
          if (this.Query[key].Checked && this.Query[key].T != null) {
            var item = this.Query[key];
            this.turnBack(item, item);
            dts.push(item);
          }
          if (this.Query[key].T == 2) {
            var item = this.Query[key];
            this.turnBack(item, item);
            dts.push(item);
          }
        }
        if (dts.length == 0 && this.data.QueryPlanId == 0) {
          this.$message.warning("请添加查询条件");
        } else {
          this.$refs.saveDialog.openCreate({ ...this.data, Dts: dts });
        }
      } else {
        var data = this.$refs.groupSearch.toSave();
        if(data) {
          if(data) this.$refs.saveDialog.openCreate(data);
        }
      }
    },
    close() {
      this.$refs.dialog.close(true);
    },
    search() {
      console.log("查询");
      var data = {};
      for (let key of Object.keys(this.Query)) {
        if (this.Query[key].Checked) {
          var item = this.Query[key];
          this.setQuery(data, item);
        }
      }
      if (Object.keys(data).length == 0) {
        this.$message.warning("请添加查询条件");
      } else {
        this.$emit("on-search", data);
        this.close(true);
      }
    },
    setQuery(data, source) {
      switch (source.ParamType) {
        case "Array":
          data[source.ApiParamName] = source.Value1;
          break;
        case "Date":
          var params = source.ApiParamName.split(",");
          data[params[0]] = source.Value1[0];
          data[params[1]] = source.Value1[1];
          break;
        case "Interval":
          var params = source.ApiParamName.split(",");
          data[params[0]] = source.Value1;
          data[params[1]] = source.Value2;
          break;
        default:
          data[source.ApiParamName] = source.Value1;
          break;
      }
    },
    onCloseSaved() {
      if (this.data.QueryPlanId != 0) this.$emit("edit-closed");
      this.close(true);
    },
    tabChange() {

    },
    onClosed() {
      this.tabActive = "0";
      this.data.QueryPlanId = 0;
      this.data.QueryPlanName = "";
      this.data.TeacherId = 0;
      this.Query = JSON.parse(JSON.stringify(require("./queryItems.json")));
      this.BaseInfo = []; //基本信息-个人基本信息
      this.Theme = []; //育人工作 - 主题班会
      this.EduHoner = []; //育人工作 - 个人德育类荣誉
      this.EduAward = []; //育人工作 - 个人德育类奖项
      this.ClassAward = []; //育人工作 - 所带班级表彰获奖
      this.OpenClass = []; //课程教学 - 公开课
      this.Edu1Race = []; //课程教学 - 教学1类竞赛获奖
      this.Edu2Race = []; //课程教学 - 教学2类竞赛获奖
      this.TeachHoner = []; //课程教学 - 教学类荣誉
      this.Paper = []; //教科研 - 论文发表
      this.EduProject = []; //教科研 - 教育科研项目
      this.Book = []; //教科研 - 著作出版
      this.EduResult = []; //教科研 - 教育教学科研成果
      this.Group = []; //示范引领 - 参加学术团体
      this.GuideTeacher = []; //示范引领 - 指导教师
      this.Lecture = []; //示范引领 - 专题讲座
      this.ComHoner = []; //示范引领 - 综合性荣誉称号
      this.GuideStudent = []; //指导学生 - 指导学生
      this.Train = []; //学习培训 - 学习培训
    },
  },
};
</script>
<style lang="scss">
$b-color: #dcdfe6;
$row-height: 38px;
.query-box {
  .el-collapse {
    .el-collapse-item {
      .el-collapse-item__wrap {
        border-bottom: none;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
  }
  .row-border {
    padding: 0px;
    min-height: 60px;
    border: 1px solid $b-color;
  }
  .property-row {
    min-height: $row-height;
    line-height: $row-height;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .row-title {
      width: 80px;
      text-align: center;
      background-color: #daeeff;
      border-right: 1px solid $b-color;
    }
    .row-content {
      width: calc(100% - 80px);
      .subrow {
        display: inline-block;
        height: $row-height;
        .subtitle {
          min-height: $row-height;
          width: 80px;
          text-align: center;
          background-color: aliceblue;
          // border-right: 1px solid $b-color;
          display: inline-block;
        }
        .subcontent {
          min-height: $row-height;
          display: inline-block;
        }
      }
      label {
        display: inline-block;
        padding: 0px 10px;
        margin: 0;
      }
    }
  }
  .property-row + .property-row {
    border-top: 1px solid $b-color;
  }
  .query-row {
    min-height: $row-height;
    line-height: $row-height;
    border: 1px solid #ebeef5;
    .item-row {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      .row-title {
        width: 130px;
        padding: 0 7px;
        text-align: center;
        // background-color: #daeeff;
        border-right: 1px solid #ebeef5;
      }
      .row-content {
        width: calc(100% - 130px);
        .el-form-item {
          margin: 0px 0px 0px 5px;
          display: inline-block;
          .el-form-item__content {
            min-width: 210px;
            .el-date-editor {
              width: 210px;
            }
          }
        }
      }
    }

    .item-row + .item-row {
      border-top: 1px solid #ebeef5;
    }
  }
}
.hideHeader .el-tabs__header {
  display: none;
}
</style>